// extracted by mini-css-extract-plugin
module.exports = {"container":"CartBadge_container__GPo6s","badge":"CartBadge_badge__t1UJd","pcBadge":"CartBadge_pcBadge__471k8","iconAlign":"CartBadge_iconAlign__q1p5T"};